export const orEmpty = (value: string | null | undefined): string => value || '';
